import React, { useState } from "react";
import { Drawer } from "../components/Elements/appUtils";
import AddCustomerComponentPos from "./addCustomerComponentPos";
import ChooseCustomerPos from "./chooseCustomerPos";

const AddCustomerDrawerPos = (props) => {
  const [customerId, setCustomerId] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState(null);
  let { visible, onClose, onSubmit } = props;
  return (
    <>
      <Drawer
        placement="right"
        onClose={onClose}
        visible={visible}
        width="800px"
        title={"Add Customer"}
      >
        <AddCustomerComponentPos onClose={onClose} onSubmit={onSubmit}  selectedCustomer={selectedCustomer}/>
        <div>
          <h2>Search Customer</h2>
          <ChooseCustomerPos
            customerId={customerId}
            callback={(clientData) => {
              if (clientData && clientData._id) {
                setCustomerId(clientData._id);
                  setSelectedCustomer(clientData);
                onSubmit(clientData)
              }
            }}
          />
        </div>
      </Drawer>
    </>
  );
};
export default AddCustomerDrawerPos;
